import type { VisualPayload } from "../../types";
import CardShell from "./_CardShell";
import RankList, { type RankEntry } from "./_RankList";
import PassageList, { type Passage } from "./_PassageList";

interface Props { payload: VisualPayload }

/** League meta: the ranked meta list, else the retrieved passages
 * (`rag_context`), else an empty-state line. */
export default function MetaCard({ payload }: Props) {
  const metaSec = payload.sections.find((s) => s.section === "meta_list");
  const entries = (metaSec?.entries as RankEntry[]) ?? [];
  const ragSec = payload.sections.find((s) => s.section === "rag_context");
  const chunks = (ragSec?.chunks as Passage[] | undefined) ?? [];
  const empty = <p className="text-sm text-white/40">No meta data available.</p>;

  return (
    <CardShell title={payload.title} source={payload.data_source} timestamp={payload.data_timestamp} sourceUrl={payload.source_url} shareUrl={payload.share_url} snapshotPayload={payload.snapshot_eligible ? payload : undefined}>
      {entries.length === 0 && chunks.length > 0 ? (
        <PassageList passages={chunks} empty={empty} />
      ) : (
        <RankList entries={entries} empty={empty} />
      )}
    </CardShell>
  );
}
